import { put, takeEvery } from "redux-saga/effects";

import {
  FETCH_USERS_INIT_ACTION,
  FETCH_USERS_SUCCESS_ACTION,
  FETCH_USERS_FAIL_ACTION,
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchUsers(value) {
  const token = localStorage.getItem("token");

  //For pagination purpose
  let pageno = (!(value.value)) ? 1 : (value.value.pageno === undefined ? 1 : value.value.pageno);
  let status = (!(value.value)) ? "" : (value.value.filter === "" ? "" : value.value.filter);
  let query = (!(value.value)) ? "" : (value.value.queryToSearch === "" ? "" : value.value.queryToSearch);

  try {
    const res = yield fetch(
      `${appConfig.ip}/users?role=distributor&limit=10&page=${pageno}&status=${status}&search=${query}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_USERS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_USERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* userActionWatcher() {
  yield takeEvery(FETCH_USERS_INIT_ACTION, fetchUsers);
}
